import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setFactoryArea = (state, { factoryArea }) => {
  if (!factoryArea) return state;
  return state.merge({ factoryArea });
};

const setFactoryAreaDetails = (state, { factoryAreaDetails }) => {
  if (!factoryAreaDetails) return state;
  return state.merge({ factoryAreaDetails });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_FACTORY_AREA,
    actionFunction: setFactoryArea,
  },
  {
    actionType: ActionTypes.SET_FACTORY_AREA_DETAILS,
    actionFunction: setFactoryAreaDetails,
  },
];
